<ng-container *ngIf="images?.length > 0">
  <img *ngIf="animationDone" src="{{images[index].url}}"
       @carouselAnimation
       (@carouselAnimation.done)="animationDone = true"
       (swiperight)="goPrevious()"
       (swipeleft)="goNext()">
<!--  <ng-container *ngFor="let slide of images; let i = index">-->
<!--    <div class="image">-->
<!--      <img-->
<!--        *ngIf="i === index && animationDone"-->
<!--        src="{{slide?.url}}"-->
<!--        @carouselAnimation-->
<!--        (@carouselAnimation.done)="animationDone = true"-->
<!--        (swiperight)="goPrevious()"-->
<!--        (swipeleft)="goNext()"-->
<!--      />-->
<!--    </div>-->
<!--  </ng-container>-->
  <app-menu-progress-stepper *ngIf="isMobileResolution()" [currentIndex]="selectedImageIndex"
                             [numberOfSteps]="images?.length" [points]="true"></app-menu-progress-stepper>
  <div class="buttons" *ngIf="images.length > 1">
    <app-button *ngIf="!isMobileResolution()" [disabled]="this.index == 0" mat-icon-button (clicked)="goPrevious()">
      <mat-icon>{{getBackIcon()}}</mat-icon>
    </app-button>
    <div *ngFor="let item of [].constructor(numberOfBottomImages); let i = index">
      <img class="bottom-image" [ngClass]="{'selected-image': selectedImageIndex == i + imagesIndexOffset}"
           *ngIf="i + imagesIndexOffset < images.length" src="{{images[i + imagesIndexOffset].url}}">
    </div>
    <app-button *ngIf="!isMobileResolution()" [disabled]="this.index == images?.length - 1" mat-icon-button (clicked)="goNext()">
      <mat-icon>{{getForwardIcon()}}</mat-icon>
    </app-button>
  </div>

</ng-container>


<img *ngIf="images?.length == 0" class="no-photo" src="assets/images/no-photo.svg"/>
